import { Controller } from '@hotwired/stimulus'
import urlParam from '../utils/urlParam'

export default class extends Controller {
  static targets = ['step1', 'step2', 'backButton', 'buttonCard']
  static values = {
    step: 1,
    title: '',
    path: ''
  }

  connect() {
    this.stepValue = urlParam.get('step') || 1
    this.titleValue = urlParam.get('title')
    this.pathValue = urlParam.get('path')

    if (this.stepValue == 2) {
      if (this.titleValue && this.pathValue) {
        this.updateBackTitle(this.titleValue)
        this.updateVesselLink(this.pathValue)
      } else {
        // if values of step 2 are not set, redirect to step 1
        this.stepValue = 1
        urlParam.set('step', 1)
      }
    }

    this.updateActiveStep()
  }
  updateActiveStep() {
    this.step1Target.classList.remove('is-active')
    this.step2Target.classList.remove('is-active')
    if (this.stepValue === 1) {
      this.step1Target.classList.add('is-active')
    } else if (this.stepValue === 2) {
      this.step2Target.classList.add('is-active')
    }
  }

  updateUrlParams() {
    urlParam.bulk([
      { name: 'step', value: this.stepValue },
      { name: 'title', value: this.titleValue },
      { name: 'path', value: this.pathValue }
    ])
  }

  goToStep2(event) {
    const { title, path } = event.currentTarget.dataset
    this.withViewTransition(() => {

      this.stepValue = 2
      this.titleValue = title
      this.pathValue = path
      this.updateUrlParams()

      this.updateActiveStep()

      this.updateBackTitle(title)
      this.updateVesselLink(path)
    }, 'forward')
  }

  backToStep1() {
    this.withViewTransition(() => {
      this.stepValue = 1
      this.titleValue = ''
      this.pathValue = ''
      this.updateUrlParams()

      this.updateActiveStep()
    }, 'back')
  }

  updateBackTitle(title) {
    if (this.hasBackButtonTarget) {
      this.backButtonTarget.dataset.componentButtonBackTitleValue = title
    }
  }

  updateVesselLink(path) {
    if (this.hasButtonCardTarget) {
      this.buttonCardTargets.forEach(target => {
        target.href = target.dataset.href.replace(`/$tool`, `/${path}`)
      })
    }
  }

  withViewTransition(callback, direction) {
    if (typeof document.startViewTransition === 'function') {
      const root = document.documentElement
      if (direction === 'forward') {
        root.style.setProperty('--lobby-old-animation', 'lobby-slide-out-left')
        root.style.setProperty('--lobby-new-animation', 'lobby-slide-in-from-right')
      } else if (direction === 'back') {
        root.style.setProperty('--lobby-old-animation', 'lobby-slide-out-right')
        root.style.setProperty('--lobby-new-animation', 'lobby-slide-in-from-left')
      }
      const transition = document.startViewTransition(callback)
      transition.finished.finally(() => {
        root.removeAttribute('data-lobby-transition')
        root.style.removeProperty('--lobby-old-animation')
        root.style.removeProperty('--lobby-new-animation')
      })
      return transition
    } else {
      callback()
      document.documentElement.removeAttribute('data-lobby-transition')
    }
  }
}